<template>
  <div>
    <Poptip
      transfer
      ref="popover"
      width="340"
      offset="25"
      placement="right-start"
      trigger="hover"
      popper-class="popper-set-class"
      @on-popper-show="showPop"
    >
      <span class="pop-text">{{textData}}</span>
      <renzheng-table slot="content" :data="moneySetData" :type="'popover'"></renzheng-table>
    </Poptip>
  </div>
</template>
<script>
import bus from '@/components/eventBus.js'
import renzhengTable from './renzhengTable.vue'
export default {
  components: {
    renzhengTable
  },
  data() {
    return {
      moneySetData: []
    }
  },
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  computed: {
    textData() {
      var level = ['免费会员', '初级会员', '中级会员', '高级会员']
      return level[this.rowData.hy_level]
    }
  },
  watch: {
    rowData() {
      this.setInitData()
    }
  },
  mounted() {
    this.setInitData()
    bus.$on('hidePopFun', () => {
      this.hidePopFun()
    })
  },
  methods: {
    hidePopFun() {
      if (this.$refs.popover) {
        this.$refs.popover.visible = false
      }
    },
    // 初始化浮窗数据
    setInitData() {
      this.moneySetData = [
        { // 会员费用
          label: '会员费用',
          labelWidth: 55,
          col: [
            { field: 'type', title: '会员类型', width: 100, titleAlign: 'left', columnAlign: 'left' },
            { field: 'sectionMoney', title: '标准费用', width: 100, titleAlign: 'left', columnAlign: 'left' },
            { field: 'money', title: '优惠后费用', width: 100, titleAlign: 'left', columnAlign: 'left' }
          ],
          data: [
            { type: '初级会员', min: 5000, max: 20000, money: '', val: '', showTips: false },
            { type: '中级会员', min: 20000, max: 50000, money: '', val: '', showTips: false },
            { type: '高级会员', min: 50000, max: 100000, money: '', val: '', showTips: false }
            // { type: '初级会员', min: 0.01, max: 20000, money: '', val: '', showTips: false },
            // { type: '中级会员', min: 0.02, max: 50000, money: '', val: '', showTips: false },
            // { type: '高级会员', min: 0.03, max: 100000, money: '', val: '', showTips: false }
          ]
        },
        { // 流量费用
          label: '流量费用',
          labelWidth: 55,
          col: [
            { field: 'type', title: '流量类型', width: 100, titleAlign: 'left' },
            { field: 'sectionMoney', title: '标准费用', width: 100, titleAlign: 'left' },
            { field: 'money', title: '优惠后费用', width: 100, titleAlign: 'left' }
          ],
          data: [
            { type: '调研次数', min: 500, max: 2000, money: '', val: '', showTips: false },
            { type: '基础报告', min: 400, max: 2000, money: '', val: '', showTips: false },
            { type: '直播场次', min: 100, max: 500, money: '', val: '', showTips: false }
          ]
        }
      ]
      // 设置会员费用数据
      const vipDataMoney = this.rowData.hy_list_std.map(item => {
        return item.hy_level_money
      })
      let vipDataVal = []
      if (this.rowData.hy_list_sale && this.rowData.hy_list_sale.length !== 0) {
        vipDataVal = this.rowData.hy_list_sale.map(item => {
          return item.hy_level_money_coupon
        })
      }
      this.moneySetData[0].data.map((item, index) => {
        item.money = vipDataMoney[index]
        item.val = vipDataVal[index]
      })
      // end
      // 设置流量费用数据
      const flowDataMoney = [this.rowData.coupon_money_std.money_config_report, this.rowData.coupon_money_std.money_config_base_report, this.rowData.coupon_money_std.money_config_live]
      let flowDataVal = []
      if (this.rowData.coupon_money_sale) {
        flowDataVal = [this.rowData.coupon_money_sale.money_config_report_coupon, this.rowData.coupon_money_sale.money_config_base_report_coupon, this.rowData.coupon_money_sale.money_config_live_coupon]
      }
      this.moneySetData[1].data.map((item, index) => {
        item.money = flowDataMoney[index]
        item.val = flowDataVal[index]
      })
      // end
    },
    // visible:true
    // 浮窗超出屏幕重新计算浮窗top值
    showPop() {
      const bodyHeight = document.body.offsetHeight
      const popPosition = document.querySelectorAll('.popper-set-class')[this.index].style.top.split('px')[0] // 当前浮窗top值
      if (bodyHeight - popPosition < 334) {
        setTimeout(() => {
          this.$nextTick(() => {
            const topNum = bodyHeight - 364
            document.getElementsByClassName('popper-set-class')[this.index].style.top = topNum + 'px' // 设置新top值
          }, 200)
        }, 0)
      }
    }
  }
}
</script>
<style lang="scss">
.pop-text {
  cursor: pointer;
  text-decoration: underline;
  user-select: none;
}
.popper-set-class {
  // top: auto !important;
}
.ivu-poptip-arrow {
  display: none;
}
</style>
